<template>
  <v-card
    flat
    class="pa-8 dropzone"
    @dragenter.prevent="toggleActive"
    @dragleave.prevent="toggleActive"
    @dragover.prevent
    @drop.prevent="toggleActive"
    :class="active ? 'active-dropzone' : ''"
  >
    <AppkitIcon :icon="'icon-upload-outline'" :size="'large'" />
    <p class="mt-2">Drag and drop file</p>
    <p>(.xlsx, .csv)</p>
    <p class="mt-2 mb-2">OR</p>
    <label for="dropzoneFile">Select File</label>
    <input
      type="file"
      id="dropzoneFile"
      class="dropzoneFile"
      accept=".xlsx, .csv"
    />
  </v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";

const active = ref(false);
function toggleActive() {
  return (active.value = !active.value);
}
</script>

<style lang="scss">
.dropzone {
  border: 1px dashed var(--grey26);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  label {
    border-radius: 6px;
    padding: 8px 12px;
    border: 2px dashed var(--yellow);
    transition: 0.3s ease all;
    &:hover {
      cursor: pointer;
      background-color: var(--light-tangerine-3);
    }
  }

  input {
    display: none;
  }
}

.active-dropzone {
  background-color: var(--light-tangerine-4);

  label {
    background-color: var(--light-tangerine-4);
  }
}
</style>
